/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { Endpoint } from '../index';
import { z, ZodTypes } from '../zod';

const Params = z.strictObject({
  organizationId: ZodTypes.Id,
  projectId: ZodTypes.Id,
  clusterId: ZodTypes.Id,
});

export const GetClusterCredentialsCypex = {
  id: 'cluster-credentials-cypex.get',
  tag: 'Cluster',
  summary: 'Get cypex cluster credentials',
  description: 'Retrieve the credentials of a cypex cluster',
  method: 'get',
  flags: { isAuthorized: true },
  route: (params: z.infer<typeof Params>) =>
    `/organization/${params.organizationId}/project/${params.projectId}/cluster/${params.clusterId}/credentials-cypex`,
  request: {
    params: Params,
  },
  response: {
    200: {
      description: 'successful',
      content: {
        'application/json': {
          schema: z.strictObject({
            host: z.string().min(1),
            port: z.number().min(0),
            username: z.string().min(1),
            password: z.string().min(1),
          }),
        },
      },
    },
  },
} as const satisfies Endpoint;
